import { Theme, useMediaQuery } from '@mui/material';

/**
 * Returns `true` when the viewport matches the shared "mobile" breakpoint
 * (everything below the `md` breakpoint)
 *
 * @returns Whether the current viewport is considered mobile
 */
export function useIsMobile(): boolean {
  return useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));
}
